import React, { Component } from "react";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import { getFileStatus } from "../../utils/fileStatus";
import ExcelDeviationTakeSubReport from "./ExcelDeviationTakeSubReport";

interface AllProps {
    reports: any;
    getBranch: any;
    redirectToDashboard?: any;
}

export default class DeviationTakeReportTable extends Component<AllProps> {
    render() {
        const { reports = [], redirectToDashboard = () => { } } = this.props;

        const columns = [
            {
                header: 'S.no',
                key: 'serial',
                td: (item: any) => <span onClick={() => redirectToDashboard(item.id)}>{item.serial}</span>,
            },
            {
                header: 'File Name',
                key: 'file_no',
                td: (item: any) => <span onClick={() => redirectToDashboard(item.id)}>{item.file_no}</span>,
            },
            {
                header: 'Bank Name',
                key: 'bank_name',
                td: (item: any) => <span onClick={() => redirectToDashboard(item.id)}>{item.bank_name} ({item.product})</span>,
            },
            {
                header: 'Process Officer',
                key: 'po_name',
                td: (item: any) => <span onClick={() => redirectToDashboard(item.id)}>{item.po_name}</span>,
            },
            {
                header: 'Update Date',
                key: 'updated_dt',
                td: (item: any) => <span onClick={() => redirectToDashboard(item.id)}>{item.updated_dt}</span>,
            },
            {
                header: 'Login Date',
                key: 'login_date',
                td: (item: any) => <span onClick={() => redirectToDashboard(item.id)}>{item.login_date}</span>,
            },
        ];

        const processedData = reports.map((report, index) => ({
            serial: index + 1,
            id: report.id,
            file_no: report.file_no ? report.file_no : "",
            lh_branch: report.lh_branch ? report.lh_branch : "",
            bank_name: report.bank_name,
            product: report.product_name ? report.product_name : "",
            bank_branch_name: report.branch_name ? report.branch_name : "",
            borrower_name: report.borrower_name ? report.borrower_name : "",
            owner_name: report.property_owner ? report.property_owner : "",
            app_id: report.app_id ? report.app_id : "",
            login_date: report.login_dt ? report.login_dt : "",
            updated_dt: report.updated_dt ? report.updated_dt : "",
            createdDt: report.createdDt ? report.createdDt : "",
            summaryAt: report.summaryAt ? report.summaryAt : "",
            po_name: report.po_name ? report.po_name : "",
            file_status: report.file_status ? getFileStatus(report.file_status) : "",
            trainingNeeded: report.trainingNeeded ? report.trainingNeeded : "",
            specialFile: report.specialFile ? report.specialFile : "",
            requestedBy: report.requestedBy ? report.requestedBy : "",
            deviation_init_userName: report.deviation_init_userName ? report.deviation_init_userName : "",
            deviation_req_userName: report.deviation_req_userName ? report.deviation_req_userName : "",
            designation: report.designation ? report.designation : "",
            deviationTaken: report.deviationTaken ? report.deviationTaken : "",
            requestReason: report.requestReason ? report.requestReason : "",
            doubtLocation: report.doubtLocation ? report.doubtLocation : "",
            summary: report.summary ? report.summary : "",
            trainingToWhom: report.trainingToWhom ? report.trainingToWhom : "",
            trainingArea: report.trainingArea ? report.trainingArea : "",
            phoneNo: report.phoneNo ? report.phoneNo : "",
            knowledgeAssessment: report.knowledgeAssessment ? report.knowledgeAssessment : "",
        }));

        return (
            <div className="">
                <div className="row">
                    <div className="col-xl-12 col-md-12 p-3">
                        {processedData && processedData.length > 0 && <ExcelDeviationTakeSubReport data={processedData} />}
                    </div>
                </div>
                <ReactFlexyTable
                    className="assigned-table"
                    data={processedData}
                    columns={columns}
                    sortable
                    pageSize={10}
                    globalSearch
                />
            </div>
        );
    }
}
